<template>
  <div class="opera-indexDetail">
    <topNav :title="$t('opera_index_detail_title')"></topNav>

    <div class="topNav clearfix topDis">
      <datepik @change='dateChange' ref="datepik" limit="pre" step="1"></datepik>
    </div>
    <template v-for="item in report">
      <div class="chartform" :key="item.code">
        <table>

          <tr class="tableCon">
            <td>
              <p class="Con_tt">{{$t('indexDetail_rentRate')}}</p>

              <p class="Con_ff">{{item.rentRate }}%</p>

            </td>
            <td>
              <p class="Con_tt">REVPAR</p>

              <p class="Con_ff">
                <small>￥</small>
                {{item.revPar}}
              </p>
            </td>
            <td>
              <p class="Con_tt">{{$t('indexDetail_revenue')}}</p>
              <p class="Con_ff">
                <small>￥</small>
                <span v-html="fnum(item.revenue)"></span></p>
            </td>

          </tr>
          <tr class="tableCon">
            <td>
              <p class="Con_tt">{{$t('indexDetail_roomrevenue')}}</p>
              <p class="Con_ff">
                <small>￥</small>
                <span v-html="fnum(item.roomrevenue)"></span>
              </p>
            </td>
            <td>

              <p class="Con_tt">{{$t('indexDetail_foodrevenue')}}</p>
              <p class="Con_ff">
                <small>￥</small>
                <span v-html="fnum(item.foodrevenue)"></span>
              </p>
            </td>
            <td>

              <p class="Con_tt">{{$t('indexDetail_otherrevenue')}}</p>
              <p class="Con_ff">
                <small>￥</small>
                <span v-html="fnum(item.otherrevenue)"></span>
              </p>
            </td>

          </tr>

        </table>
      </div>
    </template>
  </div>
</template>
<script>
  import {Toast} from 'mint-ui';
  import _ from 'lodash'
  import moment from "moment";
  import datepik from "../operaCommon/datepik";

  export default {
    data() {
      return {
        searchOption: {
          date: null,//日期（空时当前营业日）
          pageIndex: 1,
          pageSize: 20,
          sort: 'rentRate'
        },

        report: [],
        showRevenueState: false,
        selected: 0,
        loading: false,
        nextBtn: false,
        totalCount: 0,
        dis: "k"
      }
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        this.$http.post('/mobilepmsapi/opera/report/getHomeInfoDetail', this.searchOption).then(res => {
          if (res.data.result == 0) {
            this.report = res.data.retVal.list;
            this.loading = false;
            this.dis = this.report[0].dis;
            this.$refs.datepik.setDateInit(res.data.retVal.d,
              this.searchOption.date == null ? res.data.retVal.d : this.searchOption.date);
          } else {
            Toast({
              message: res.data.msg,
              position: 'bottom',
              duration: 3000
            });
          }
        })
      },
      selectList(item) {
        this[item] = ~this[item];
      },

      getNextPage() {
        if (this.nextBtn) {
          this.searchOption.pageIndex += 1;
          this.loading = true;
          this.getData();
        }
      },
      dateChange(time) {
        this.searchOption.date = time;
        this.getData();
      },
      fnum(v) {
        if (this.dis == "w" && v > 10000) {
          return (v / 10000).toFixed(2) + " <small>万</small>"
        }
        if (this.dis == "k" && v > 1000) {
          return (v / 1000).toFixed(2) + " <small>K</small>"
        } else {
          return v;
        }

      }
    },
    filters: {
      moneyF(v) {
        return v >= 1000 ? (v / 1000).toFixed(2) + "K" : v;
      }
    },
    components: {
      datepik
    }
  }
</script>
<style lang='less'>
  .opera-indexDetail {
    height: auto !important;
    // background-color: #F6F8F9;
    .topNav {
      /*z-index: 1000;*/
      height: 40px;
      background-color: #fff;
      width: 100%;
      box-sizing: border-box;
      padding: 0;

      .zb {
        float: rightleft;
        height: 40px;
        line-height: 40px;
      }

      .reveune {
        width: 4rem;
        float: right;

        i {
          font-size: 0.5rem;
          color: #999;
        }

        .selected {
          overflow: hidden;
          height: 100%;
          line-height: 40px;
          box-sizing: border-box;
          padding-right: 16px;
          text-align: center;
          padding-left: 10px;
          background-color: #fff;

        }

        .list {
          overflow: hidden;
          height: 100%;
          line-height: 40px;
          box-sizing: border-box;
          padding-right: 16px;
          text-align: center;
          padding-left: 10px;
          background-color: #fff;

          &.active {
            background-color: #eee;
          }
        }

        .icon-xia {
          right: 10px;
        }

        &.show {
          overflow: visible;

          .icon-xia {
            transform: rotate(180deg);
          }
        }
      }
    }

    .chartform {
      width: 96%;
      margin: 0 auto;
      margin-top: 10px;
      box-shadow: 5px 0px 20px #ddd;
      border-radius: 3px;
      background: #fff;
      padding-bottom: 15px;

      svg {
        width: 20px;
        height: 20px;
        float: left;
        margin-top: 6px;
      }

      table {
        width: 100%;

        tr {
          td {
            width: 33%;
            height: 41px;
            text-align: center;
            position: relative;

            h3 {
              padding-left: 10px;
              font-size: 14px;
              height: 30px;
              line-height: 30px;
              text-align: left;

              span {
                font-size: 20px;
                font-weight: bold;
                color: #999
              }
            }
          }
        }

        .tableCon {
          height: 72px;

          .Con_tt {
            color: #aaa;
            font-size: 12px;
            line-height: 20px;
          }

          .Con_ff {
            font-size: 22px;
            line-height: 34px;
          }

          .Con_ff small {
            vertical-align: baseline;
            font-size: .32rem;
          }
        }
      }
    }

    /*.flip-list-enter {
		background-color: red;
    }*/

    .more {
      width: 100px;
      text-align: center;
      overflow: hidden;
      margin: 0 auto;
      height: 40px;
      background: #FFF;
      line-height: 40px;
      margin-top: 10px;
      border-radius: 5px;
      margin-bottom: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// indexDetail.vue?9a689172